// ファイル名の拡張子だけを見て種類を判別するユーティリティ。
// 取り込みの受け付け判定と zip の中身の絞り込みで同じ判定を使うため、定義はここ1か所に置く。

// 取り込むファイルとして受け付ける拡張子かどうか。大文字小文字は区別しない。
export function isZipFileName(fileName: string): boolean {
  return fileName.toLowerCase().endsWith(".zip");
}

export function isCsvFileName(fileName: string): boolean {
  return fileName.toLowerCase().endsWith(".csv");
}
